exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".maasik-data-changed\r\n{\r\n    color: red;\r\n}\r\n.btn-first-row\r\n{\r\n    border: 1px solid;\r\n    height: 34px;\r\n    line-height: initial!important;\r\n}\r\n.btn-first-row:hover\r\n{\r\n    background-color: #007ad9;\r\n    color: #fff;\r\n}\r\n.btn-first-row-2\r\n{\r\n    border: 1px solid;\r\n    height: 34px;\r\n    line-height: initial!important;\r\n}\r\n.btn-first-row-2:hover\r\n{\r\n    background-color: #007ad9;\r\n    color: #fff;\r\n}\r\n:host ::ng-deep .ui-calendar-button\r\n{\r\n    border-top-left-radius: 5px!important;\r\n    border-top-right-radius: 0px!important;\r\n    border-bottom-left-radius: 5px!important;\r\n    border-bottom-right-radius: 0px!important;\r\n}\r\n:host ::ng-deep .ui-calendar .ui-inputtext\r\n{\r\n    border-right: 1px solid!important;\r\n    border-right-color: #a6a6a6!important;\r\n    border-top-right-radius: 5px!important;\r\n    border-bottom-right-radius: 5px!important;\r\n    border-top-left-radius: 0px!important;\r\n    border-bottom-left-radius: 0px!important;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/ProjectsOnGit/USilence/USilence/Client/src/app/MSVFile/complete-data/complete-data.component.css
// module id = ../../../../../src/app/MSVFile/complete-data/complete-data.component.css
// module chunks = main